import { Injectable } from '@angular/core';
import { ThemeSetting } from '../objects/ThemeObject';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeSettingService {

  private theme:ThemeSetting = new ThemeSetting();

  themeSettingSubject: Subject<ThemeSetting> = new Subject<ThemeSetting>();
  themeSettingChanged$ = this.themeSettingSubject.asObservable();

  constructor() {}

  setTheme(theme:ThemeSetting){
    this.theme = theme;
    this.themeSettingSubject.next(theme);
  }

  getTheme(){
    return this.theme;
  }

  clearToaster(){
    this.theme = null;
  }
}
